import { SDUIComponentInstanceRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { RenderCategoryLayoutElement } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/RenderCategoryLayoutElement";
import React from "react";

export const SDUICategoryPageLayoutElementRenderer: React.FC<
  SDUIComponentInstanceRendererProps
> = ({ component, loggingData }) => {
  const layoutElement = component.layout_element;
  if (!layoutElement) {
    return null;
  }

  return (
    <RenderCategoryLayoutElement
      layoutElement={layoutElement}
      requestId={loggingData.request_id ?? ""}
      omitCategoryPageStyling
    />
  );
};
